import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"cross\"><path fill=\"currentColor\" d=\"M24 2.53L21.47 0 12 9.47 2.53 0 0 2.53 9.47 12 0 21.47 2.53 24 12 14.53 21.47 24 24 21.47 14.53 12 24 2.53z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol